// hooks
import { useAdParams } from '@composables/tools/ad-params.hook'

export default defineNuxtPlugin(() => {
  const refAdParams = useAdParams()

  onNuxtReady(() => {
    refAdParams.value = window.location.search
  })
})
